/* @flow */
import React from 'react';
import cx from 'classnames';

import Text from 'components/Text';
import Image from 'components/Image';
import Link from 'components/Link';
import LayerTrigger from 'components/LayerTrigger';
import Tooltip from 'components/Tooltip';
import Glyph from 'components/Glyph';
import Button from 'components/ButtonDeprecated';
import Hovercard from 'components/Hovercard';
import HovercardBody from 'components/HovercardBody';

type Props = {
  item: *,
  registerHovercardTrigger: (*) => void,
  handleItemClicked: () => void,
  handleThumbnailClicked: () => void,
};

type State = {
  imageIsLandscape: boolean,
  imageLoadFailed: boolean,
};

class AccountLinkingComposerSidebarContentItem extends React.Component<Props, State> {
  state = {
    imageIsLandscape: false,
    imageLoadFailed: false,
  };

  thumbnail = null;

  handleImageLoadFailure = () => {
    this.setState({
      imageLoadFailed: true,
    });
  };

  thumbnailLoaded = () => {
    if (this.thumbnail) {
      this.setState({
        imageIsLandscape: this.thumbnail.isLandscape(),
      });
    }
  };

  showIconForFiletype = (mimeType: string) => {
    if (!mimeType) {
      return false;
    }
    if (mimeType === 'application/vnd.google-apps.folder') {
      return true;
    }
    if (mimeType.startsWith('video/')) {
      return true;
    }

    return false;
  };

  render = () => {
    const { imageLoadFailed, imageIsLandscape } = this.state;
    const {
      item,
      registerHovercardTrigger,
      handleItemClicked,
      handleThumbnailClicked,
      ...others
    } = this.props;
    const displayTitle = item.title || item.contentUrl;

    const showOverlay = item.imageUrl === '' || imageLoadFailed;

    const showIcon =
      item.imageUrl === '' || this.showIconForFiletype(item.mimeType) || imageLoadFailed;

    return (
      <div {...others} className="AccountLinkingComposerSidebarContent-item">
        <div className="AccountLinkingComposerSidebarContent-item-labels">
          <Link
            className="AccountLinkingComposerSidebarContent-item-labels-thumbnail"
            onClick={() => handleThumbnailClicked()}>
            <Image
              ref={img => (this.thumbnail = img)}
              onLoad={this.thumbnailLoaded}
              onError={this.handleImageLoadFailure}
              className={cx('AccountLinkingComposerSidebarContent-item-labels-thumbnail-image', {
                landscape: imageIsLandscape,
                portrait: !imageIsLandscape,
              })}
              src={item.imageUrl || ''}
            />
            {showOverlay && (
              <div className="AccountLinkingComposerSidebarContent-item-labels-thumbnail-overlay" />
            )}
            {showIcon && (
              <Image
                className="AccountLinkingComposerSidebarContent-item-labels-thumbnail-icon"
                src={item.fileTypeIcon}
              />
            )}
          </Link>
          <LayerTrigger
            layer={
              <Tooltip className="AccountLinkingComposerSidebarContent-tooltip">
                {displayTitle}
              </Tooltip>
            }
            trigger={['hover']}
            placement="top">
            <Link
              className="AccountLinkingComposerSidebarContent-item-labels-button"
              onClick={() => handleItemClicked()}>
              <div className="AccountLinkingComposerSidebarContent-item-labels-button-text">
                <Text color="chalkboard" size="xsmall" truncate>
                  {displayTitle}
                </Text>
                {item.title && item.description && (
                  <Text color="graphite" size="xxxsmall" truncate>
                    {item.description}
                  </Text>
                )}
              </div>
            </Link>
          </LayerTrigger>
        </div>
        <LayerTrigger
          trigger="click"
          ref={(e: any) => registerHovercardTrigger(e)}
          placement="top"
          hideLayerOnScroll
          layer={
            <Hovercard>
              <HovercardBody className="AccountLinkingComposerSidebarContent-item-hovercard">
                <Button onClick={() => handleItemClicked()} level={'text'}>
                  Attach file
                </Button>
                <Button onClick={() => handleThumbnailClicked()} level={'text'}>
                  Preview file
                </Button>
              </HovercardBody>
            </Hovercard>
          }>
          <Button
            aria-label="Actions"
            className="AccountLinkingComposerSidebarContent-item-actions"
            size="xxsmall"
            level={'icon'}
            color={'percussion'}
            onClick={() => {}}>
            <Glyph name="ellipses" solo size="medium" />
          </Button>
        </LayerTrigger>
      </div>
    );
  };
}

export default AccountLinkingComposerSidebarContentItem;
